<template lang="html">
  <component :is="component" v-bind="{ ...$attrs, ...$props }" v-on="$listeners" />
</template>

<script>
  import { mapGetters } from 'vuex';
  import SceneDefault from './default';
  import SportmasterSettingsUsersRoles from '@/process/sportmaster/components/settings/managers/UsersRoles';

  export default {
    name: 'SettingsManagersScene',

    components: {
      default: SceneDefault,
      sportmaster: SportmasterSettingsUsersRoles
    },

    computed: {
      ...mapGetters('process', ['getProcessName']),

      component() {
        if (this.getProcessName === 'sportmaster') {
          return 'sportmaster';
        } else {
          return 'default';
        }
      }
    }
  };
</script>
